import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { FilterPayload } from 'src/app/models/product-model';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import { DasboardService } from 'src/app/services/super-admin/dasboard.service';

@Component({
  selector: 'app-home-product-view',
  templateUrl: './home-product-view.component.html',
  styleUrls: ['./home-product-view.component.scss']
})
export class HomeProductViewComponent implements OnInit {

  constructor(
    private categoryService: CategoryService,
     private superAdminDashboardService: DasboardService,

  ) {}

  products: any[] = [];
  isViewAll: boolean = false;
  customersCount: number = 0;
  
  ngOnInit(): void {
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
        topOfPage.scrollIntoView({ behavior: 'smooth' });
      } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    this.getAllParentCategories();
    this.isViewAll =  window.history.state.isViewAll;
    const filterPayload: FilterPayload = {
      continents: [],  
      countries: [],     
      states: [],       
      cities: [],       
      startDate:'', 
      endDate: '',    
    };
  
    this.getSummaryData(filterPayload);
    
  }
  
  getAllParentCategories() {
    this.categoryService.getAllParentCategories().subscribe({
      next: (response) => {
        if (response.data.length > 0) {
          this.products = response.data.map((product: any) => ({
            id: product.id,
            image: product.image || 'assets/images/default-product.png',
            title: product.name || 'Untitled Product',
            subcategories: product.subcategories || [],
            productCount: product.productCount || 0,
          }));
        }
      },
      error: (err) => {
        console.error('Error fetching categories:', err);
      },
    });
  }


  getSummaryData(filterPayload: FilterPayload) {
    this.superAdminDashboardService.getProductsSummary().subscribe((products) => {
      this.customersCount = products?.data?.['totalProductsCount'] ?? 0;
    });
  }
}

